import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

const DocumentConvo = (props: any) => {
  const css = `
      .react-pdf__Page__canvas {
        margin: 0 auto;
        width: ${props.width || "100% !important"};
        height: ${props.height || "160px !important"};
    }
    .react-pdf__Page__textContent{
      display:none
    }
  `;
  
  return (
    <>
      <style>{css}</style>
      <Document
        file={props.url}
        externalLinkTarget="_blank"
        error="Failed to load preview. Kindly download"
        onPassword={()=>{}}
      >
        <Page pageNumber={1} />
      </Document>
    </>
  );
};

export default DocumentConvo;
